export default "__VITE_ASSET__CRu3xkIU__"